import axios from 'axios';

const REFRESH_ENDPOINT = '/refresh-token';

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user'));
  } catch (e) {
    return null;
  }
};

const getToken = async () => {
  const user = getStoredUser();
  const token = user?.token;

  if (token) {
    return 'Bearer ' + token.replace(/"/g, '');
  }
  return ''; 
};

const getRefreshToken = () => {
  const user = getStoredUser();
  return user?.refresh_token || user?.user?.refresh_token || '';
};

const updateStoredTokens = ({ token, refresh_token }) => {
  const user = getStoredUser();
  if (!user) {
    return;
  }
  const nextUser = {
    ...user,
    ...(token && { token }),
    ...(refresh_token && { refresh_token }),
    user: {
      ...(user.user || {}),
      ...(token && { token }),
      ...(refresh_token && { refresh_token }),
    },
  };
  localStorage.setItem('user', JSON.stringify(nextUser));
};

const getTempToken = async () => {
  const tempToken = localStorage.getItem('temp_token');

  if (tempToken) {
    return 'Bearer ' + tempToken.replace(/"/g, '');
  }
  return ''; 
};

const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    return false;
  }

  const fullApiPath = `${process.env.REACT_APP_API_URL}${REFRESH_ENDPOINT}`;
  const { data } = await axios.post(
    fullApiPath,
    { token: refreshToken },
    { headers: { 'Content-Type': 'application/json' } },
  );
  const result = data?.result || {};
  if (!result.token) {
    return false;
  }
  updateStoredTokens({
    token: result.token,
    refresh_token: result.refresh_token,
  });
  return true;
};

const shouldRefresh = (error, endpoint) => {
  const status = error?.response?.status || error?.response?.data?.status_code;
  const message = error?.response?.data?.message || error?.response?.data?.detail;
  return (
    endpoint !== REFRESH_ENDPOINT &&
    (status === 401 || status === 403) &&
    (!message || message === 'Token expired' || message === 'Invalid token')
  );
};

const requestWithRefresh = async (endpoint, request) => {
  try {
    return await request();
  } catch (error) {
    if (shouldRefresh(error, endpoint) && (await refreshAccessToken())) {
      return request();
    }
    throw error;
  }
};

export const axiosGet = async (options) => {
  let fullApiPath = `${process.env.REACT_APP_API_URL}${options.endpoint}`;
  const token = await getToken();
  return requestWithRefresh(options.endpoint, async () => {
    const refreshedToken = await getToken();
    return axios.get(fullApiPath, {
    params: options.body,
    headers: {
      'Content-Type': 'application/json',
        ...((refreshedToken || token) && { Authorization: refreshedToken || token }),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezoneOffset: new Date().getTimezoneOffset(),
    },
  });
  });
};


export const axiosPost = async (options) => {
  
  if(options.endpoint.startsWith('/verify_2fa/')){
    let fullApiPath = `${process.env.REACT_APP_API_URL}${options.endpoint}`;
    const token = await getTempToken();
  
    let res = await axios.post(fullApiPath, options.body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ,
      },
    });
  
    return res;
  }
  let fullApiPath = `${process.env.REACT_APP_API_URL}${options.endpoint}`;
  const token = await getToken();

  return requestWithRefresh(options.endpoint, async () => {
    const refreshedToken = await getToken();
    return axios.post(fullApiPath, options.body, {
    headers: {
      'Content-Type': 'application/json',
        Authorization: refreshedToken || token ,
    },
  });
  });
};

export const axiosDelete = async (options) => {
  let fullApiPath = `${process.env.REACT_APP_API_URL}${options.endpoint}`;
  const token = await getToken();

  return requestWithRefresh(options.endpoint, async () => {
    const refreshedToken = await getToken();
    return axios.delete(fullApiPath, {
    headers: {
      'Content-Type': 'application/json',
        Authorization: refreshedToken || token ,
    },
    data: options.body,
  });
  });
};

export const axiosPut = async (options) => {
  let fullApiPath = `${process.env.REACT_APP_API_URL}${options.endpoint}`;
  const token = await getToken();

  return requestWithRefresh(options.endpoint, async () => {
    const refreshedToken = await getToken();
    return axios.put(fullApiPath, options.body, {
    headers: {
      'Content-Type': 'application/json',
        Authorization: refreshedToken || token ,
    },
  });
  });
};
